import api from "./axios";

export const registerUser = (data) => api.post("/auth/register", data);
export const loginUser = (data) => api.post("/auth/login", data);
export const refreshUserSession = (data) => api.post("/auth/refresh", data);
export const getMe = () => api.get("/auth/me");
export const logoutUser = () => api.post("/auth/logout");
export const logoutAllSessions = () => api.post("/auth/logout-all");
export const getSessions = () => api.get("/auth/sessions");
export const revokeSession = (sessionId) => api.delete(`/auth/sessions/${sessionId}`);

export const requestPasswordReset = (identifier) =>
  api.post("/auth/forgot-password", { identifier });

export const resetPassword = ({ token, newPassword }) =>
  api.post("/auth/reset-password", {
    token,
    new_password: newPassword,
  });
